import { Box, Button, Divider, Paper, Typography, useTheme } from '@mui/material';
import React from 'react';
import AvatarWithText from '../../components/AvatarWithText';
import NoDataPresentUI from '../../components/NoDataPresentUI';
import CorporateDocs from '../MyCompanies/CorporateDocs';
import RenderContent from '../../components/RenderContent';
import { format } from 'date-fns';
import { post } from '../../api';

function MailMessageDetails({ selectedMailItem, toggleDrawer, isDrawer, updateAllMail }) {
    const theme = useTheme();

    const mailDetails = selectedMailItem;

    const forwardMail = () => {
        createCase({
            title: `Request support—Registered Agent`,
            subTitle: 'Request physical mail delivery, track expected mail, discuss billing options, and process other requests.',
            subject: `Request support: Registered Agent`,
            companyName: mailDetails.accountName,
            recordType: 'General Case',
            type: 'Request physical mail forwarding',
            accountId: mailDetails.companyId,
            showCustomerField: true, // show customer field
            customerLabelList: [
                { label: 'Request physical mail forwarding', value: 'RA Support' },
                { label: 'Mail tracking', value: 'RA Support' },
                { label: 'Billing', value: 'Billing' },
                { label: 'Amazon questions', value: 'RA Support' },
                { label: 'Cancelation', value: 'Billing' },
                { label: 'Other', value: 'RA Support' },
            ],
            message: 'Requesting a physical copy may include a forwarding fee.',
            callback: (recordId) => {
                post('custom/updateCaseInPortalMessage', { portalMessageId: mailDetails.id, caseId: recordId }).then((result) => {
                    console.log(result);
                });
                let messageDetail;
                updateAllMail({ ...mailDetails, caseId: recordId });
                messageDetail = { variant: 'success', message: 'Successfully requested the physical copy' };
                const event = new CustomEvent('openToster', {
                    detail: messageDetail,
                });

                document.dispatchEvent(event);
            },
        });
    };

    const createCase = (detail) => {
        const event = new CustomEvent('createCase', {
            detail: detail,
        });

        document.dispatchEvent(event);
    };

    if (!mailDetails) {
        return (
            <NoDataPresentUI
                variant={'outlined'}
                containerSx={{
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '60%',
                    },
                    marginLeft: { md: '1rem' },
                }}
                heading="Select a message to view"
                icon={<Box component={'img'} src="/images/other/cropped_no_message.png" sx={{ width: '100px', height: '100px' }} alt="no message clicked"></Box>}
            />
        );
    }
    return (
        <Paper
            variant={'outlined'}
            square={isDrawer ? true : false}
            sx={{
                overflow: 'auto',
                width: { xs: '100%', sm: '100%', md: '60%' },
                marginLeft: { md: '1rem' },
                height: { xs: '100%' },
            }}
        >
            <Box height={'100%'} width={'100%'} minWidth={{ md: '300px' }} overflow={'auto'} id="print-element">
                <Box
                    sx={{
                        padding: {
                            xs: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
                            sm: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xxxLarge}`,
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box mb={theme.typography.generic.small}>
                            <Typography component={'span'} variant="paraText6" color={'text.secondary'}>
                                {format(new Date(mailDetails.lastModifiedDate), 'MM/dd/yyyy')}
                            </Typography>{' '}
                            <Typography component={'span'} variant="paraText6" color={'text.neutralSecondary'}>
                                {format(new Date(mailDetails.lastModifiedDate), 'hh:mm a')}
                            </Typography>
                        </Box>
                        {mailDetails.type?.toLowerCase() === 'registered agent mail' && (
                            <>
                                {!mailDetails.caseId && (
                                    <Button type="button" onClick={forwardMail}>
                                        Request physical copy
                                    </Button>
                                )}
                                {mailDetails.caseId && <Typography>You’ve already requested the physical copy</Typography>}
                            </>
                        )}
                    </Box>

                    <Typography component={'h2'} variant="paraText1" color={'text.primary'}>
                        {mailDetails.subject}
                    </Typography>
                    <Box
                        sx={{
                            marginTop: `${theme.typography.generic.large}`,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <AvatarWithText img={mailDetails?.profileImage} heading={mailDetails.lastModifiedByName === 'PRIME Relay Admin'? 'PRIME Support' : mailDetails.lastModifiedByName} subHeading={mailDetails.lastModifiedByEmail} />
                    </Box>
                </Box>

                <Divider />

                <Box
                    className="Message"
                    overflow={'auto'}
                    padding={{
                        xs: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
                        sm: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xxxLarge}`,
                    }}
                >
                    <RenderContent htmlString={mailDetails.body} />
                </Box>

                {mailDetails.files?.length > 0 && (
                    <>
                        {/* <Divider /> */}
                        <Box
                            padding={{
                                xs: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
                                sm: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xxxLarge}`,
                            }}
                        >
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                <Typography variant="subtitle2" fontWeight={'fontWeightSemiBold'} component={'h3'}>
                                    Attachments
                                    <Typography component={'span'} variant="body2" fontSize={'customFontSize.small'} color={'grey.100'} ml={theme.typography.generic.xxxSmall}>
                                        ({mailDetails.files?.length} files)
                                    </Typography>
                                </Typography>
                            </Box>
                            <CorporateDocs files={mailDetails?.files}></CorporateDocs>
                        </Box>
                    </>
                )}
            </Box>
        </Paper>
    );
}

export default MailMessageDetails;
